import React, { FC, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AppOutletCont } from './AppOutlet.styles';
import SideMenu from '../../components/SideMenu/SideMenu';
import Spinner from '../../components/Spinner/Spinner';
import { useAuth } from '../../hooks/useAuth';
import { useLangManagement } from '../../hooks/useLangManagement';
import { useSyncStorage } from '../../hooks/useSyncStorage';
import { GlobalSpinnerCont } from '../../styles/globals';

const AppOutlet: FC = () => {
  useSyncStorage();
  const [loading, setLoading] = useState(false);
  const [activeView, setActiveView] = useState('surveys');
  const { langIsUpdating, lang, currentLang } = useLangManagement();
  const { updateUserPreferences, isEBHRMember } = useAuth();

  useEffect(() => {
    if (langIsUpdating && lang !== currentLang) {
      setLoading(true);
      (async () => {
        if (lang) {
          await updateUserPreferences(lang);
        }
      })();
      setTimeout(() => setLoading(false), 50);
    }
  }, [langIsUpdating, lang, currentLang]);
  return (
    <AppOutletCont>
      <SideMenu activeView={activeView} changeView={setActiveView} isEBHRMember={isEBHRMember} />
      {loading ? (
        <GlobalSpinnerCont>
          <Spinner />
        </GlobalSpinnerCont>
      ) : (
        <Outlet />
      )}
    </AppOutletCont>
  );
};

export default AppOutlet;
